import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import Participants from "@/pages/Participants";
import Clients from "@/pages/Clients";
import Guides from "@/pages/Guides";
import Payments from "@/pages/Payments";
import Accommodations from "@/pages/Accommodations";
import Transport from "@/pages/Transport";
import Itinerary from "@/pages/Itinerary";
import Finances from "@/pages/Finances";
import Tasks from "@/pages/Tasks";
import Reports from "@/pages/Reports";
import ClientPortal from "@/pages/ClientPortal";
import SelfRegister from "@/pages/SelfRegister";
import ResetPassword from "@/pages/ResetPassword";
import MarketingPage from "@/pages/marketing/MarketingPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/join" element={<SelfRegister />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="tours" element={<Tours />} />
        <Route path="tours/:id" element={<TourDetail />} />
        <Route path="participants" element={<Participants />} />
        <Route path="clients" element={<Clients />} />
        <Route path="guides" element={<Guides />} />
        <Route path="payments" element={<Payments />} />
        <Route path="accommodations" element={<Accommodations />} />
        <Route path="transport" element={<Transport />} />
        <Route path="itinerary" element={<Itinerary />} />
        <Route path="finances" element={<Finances />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="reports" element={<Reports />} />
        <Route path="marketing" element={<MarketingPage />} />
        <Route path="portal" element={<ClientPortal />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
